import { DEFAULT_USER_PAGE_TITLE, DEFAULT_USER_PAGE_URL } from "constants/menu";
import { ReactElement, ReactNode, useEffect } from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

type PageTitleProps = {
  pageTitle?: string;
  appendTitle?: ReactElement;
  baseCrumb?: {
    name?: string;
    path?: string;
  }
  parent?: string;
  crumbs?: {
    name?: string;
    path?: string;
  }[];
};

const Title = ({ pageTitle, appendTitle, baseCrumb, parent, crumbs }: PageTitleProps) => {
  useEffect(() => {
    document.title = "Z Freedom - " + pageTitle;
  }, [pageTitle]);

  function getCrumb(key: any, name?: string, path?: string) {
    if (name) {
      if (path) {
        return (
          <Breadcrumb.Item active key={key}>
            <Link to={path} key={key} className="link-secondary">
              {name}
            </Link>
          </Breadcrumb.Item>
        );
      } else {
        return (
          <Breadcrumb.Item key={key} active>
            {name}
          </Breadcrumb.Item>
        );
      }
    }
    return <></>;
  }

  return (
    <Row>
      <Col className="row-no-gutters">
        <div className="page-title-box">
          <div className="page-title-right">
            <Breadcrumb listProps={{ className: "m-0" }}>
              {getCrumb("d", baseCrumb != null ? baseCrumb.name : DEFAULT_USER_PAGE_TITLE, baseCrumb != null ? baseCrumb.path : DEFAULT_USER_PAGE_URL)}

              {crumbs && crumbs.map((c, i) => getCrumb(i, c.name, c.path))}

              {parent && <Breadcrumb.Item active>{parent}</Breadcrumb.Item>}
              <Breadcrumb.Item active>{pageTitle}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h4 className="d-inline-flex align-items-center page-title gap-2">
            {pageTitle}
            {appendTitle}
          </h4>
        </div>
      </Col>
    </Row>
  );
};

export default Title;
